import { createFileRoute } from '@tanstack/react-router'

import { AuditTrailPage } from '@/components/audit-trail/audit-trail-page'

export const Route = createFileRoute('/audit-trail')({
  component: AuditTrailPage,
})
